import * as React from 'react';
import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export default function SuccessDialog({coinsEarned = 10, initialState = false}) {
    const [solveQuestion, setSolveQuestion] = useState(true)
    const [open, setOpen] = React.useState(initialState);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {"Success"}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                You have solved it. You have earned {coinsEarned} coins.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} variant='contained'>Ok! Close</Button>
        </DialogActions>
    </Dialog>
}